import { registerEvents } from './skyward.ui.events';

const events =
{
    init
};

registerEvents("autocompleteFix", events);

/* Chrome will respect autocomplete attributes on all elements within the form/page if an element within the form/page has an enabled autocomplete attribute.*/
function init(this: HTMLElement | JQuery<HTMLElement>)
{
    const container: JQuery<HTMLElement> = $(this);
    const fixElement: JQuery<HTMLElement> = $("<input>",
        {
            attr:
            {
                style: "display:none",
                type: "text",
                name: "ChromeAutocompleteFix",
                autocomplete: "phone"
            }
        });

    fixElement.appendTo(container);
}
